module.exports = __webpack_public_path__ + "img/supplies.b2d8a26c.svg";